(function(w,d,$){
  'use strict';

  $(function(){


    // スマホカテゴリリスト
    (function(){ if(!$.UA.is_mobile) return;
      $('.ui-mobile .listContents').getCatList({
        content: 'works',
        blockClass: 'worksCat',
        addAll: true,
        linkClass:'button'
      });
    }());

  });

  $(w).on('load',function(){});

  $(w).on('list_disp',function(){


    if($.UA.is_pc){

      // 記事を外包するリンクを削除
      // $('.element_list .artloop').each(function(){
      //   $(this).unwrap('a.wrapLink');
      // });

      $('.element_list .list_imgflo').each(function(){
        // クリア用brタグ除去
        $('br.clear',this).remove();
        $(this).addClass('custom-column');
      });

      $('.artloop').parent().addClass('col-4');
      
      $('.artloop').each(function(){
        var $this = $(this),
            $container = $this,
            // $title_wrap = $('<div />',{class:'artloop__title-wrap'}),
            $date = $this.find('p.date').attr('class','artloop__date'),
            $cate = $this.find('.catetitle').attr('class','artloop__cate'),
            $title = $this.find('h5').attr('class','artloop__title'),
            $new = $this.find('span.new').attr('class','new artloop__new'),
            $catch = $this.find('p.catch').attr('class','artloop__catch'),
            $body = $this.find('p:last-child:not(.catch)').attr('class','artloop__body');

        $date.text( $date.text().replace('日','').split(/\/|\.|年|月/).join('.') );
        $cate.html( $cate.find('a').addClass('button button-xsmall') );
        $new.appendTo($title);
        $container
          // .append( $date )
          .append( $cate )
          .append( $title );
      });
    }

  });

  $(w).on('detail_disp',function(){});



}(window,document,jQuery));

